<template>
  <article class="c-system-update-card">
    <header>
      Reported on
      <slot name="postedOn"></slot>
    </header>
    <main>
      <div class="row p-top-10 p-left-10 p-right-10 p-bottom-0">
        <div class="col-xs-3">
          <p>Short Description:</p>
        </div>
        <div class="col-xs-9">
          <slot name="description" />
        </div>
        <div class="col-xs-3">
          <p>Details:</p>
        </div>
        <div class="col-xs-9">
          <slot name="details" />
        </div>
      </div>
      <div class="row p-left-10 p-right-10">
        <div class="col-xs-3">
          <p>Back Online:</p>
        </div>
        <div class="col-xs-9">
          <slot name="backOnline">N/A</slot>
        </div>
      </div>
      <div class="row p-left-10 p-right-10">
        <div class="col-xs-3">
          <p>Posted By:</p>
        </div>
        <div class="col-xs-9">
          <slot name="postedBy"></slot>
        </div>
      </div>
      
    </main>
  </article>
</template>

<script>
export default {
    name: 'SystemUpdateCard'
};
</script>

<style lang="scss" scoped>
.c-system-update-card {
  border: 1px solid grey;
  margin-bottom: 50px;
  background: $colour-nhs-core-white;

  header {
    padding: 10px;
    background: $colour-nhs-core-blue;
    color: $colour-nhs-core-white;
    font-family: $font-frutiger-bold;
  }
  dl {
    line-height: 2;
    margin: 0;
    dt {
      width: 25%;
      float: left;
      clear: left;
      padding: 10px;
      border-bottom: 1px solid $colour-nhs-med-grey;

      &:last-of-type {
        border: none;
      }
    }
    dd {
      padding: 10px;
      border-bottom: 1px solid $colour-nhs-med-grey;
      &:last-of-type {
        border: none;
      }
    }
    // display: flex;
    // flex-direction: row;
    // flex-wrap: wrap;
    // width: 100%;
    // dt {
    //   font-weight: bold;
    //   display: flex;
    //   flex-direction: column;
    //   flex-basis: 100%;
    //   flex: 1;
    // }
    // dd {
    //   color: red;
    //   display: flex;
    //   flex-direction: column;
    //   flex-basis: 100%;
    //   flex: 1;
    // }
  }
}
</style>